import React from 'react';
import styled from 'styled-components';
import { ProgramCategory } from '@gql/generated';
import { Anchor } from '@organisms/cards/OfferCard';
import { Card } from '@organisms/cards/ProgramListingCard';

const Body = styled.div<{ appearance?: ProgramCategory }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  text-align: center;
  /* padding: 15% 10px; */
`;

const Image = styled.img`
  width: 100%;
  min-height: 100%;
  object-fit: cover;
`;

export const PromotionCard = ({ className = '', link, img }) => {
  return (
    <Anchor className={className} href={link} target="_blank">
      <Card data-testid="TrialCard">
        <Body>
          <Image src={img} />
        </Body>
      </Card>
    </Anchor>
  );
};
